import {bbox as bboxStrategy} from 'ol/loadingstrategy';
import {EsriJSON, GeoJSON} from "ol/format";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {
    getBookmarkPresentationsByID, getLayerAttributes,
    getLayerNamePrefix,
    removeLoaderByBookmarkPresentationID
} from "@/helpers/ol/ol-layer-helper";
import {getWfsStyle} from "@/helpers/ol/wfs/wfs-style-helper";
import {callService} from "@/helpers/ol/ol-http-helper";
import {hexToRgba} from "@/helpers/color-helper";
import {loadTemporaryLayerInfo} from "@/helpers/layer/temporary/temporary-layer-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import VectorTileLayer from "ol/layer/VectorTile";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {Fill, Stroke, Style} from "ol/style";
import {getDefaultStyles} from "@/helpers/ol/ol-style-helper";
import {loadLinkedData} from "@/helpers/layer/info/layer-info-info-linked-data-helper";
import {Point} from "ol/geom";
import {getMoveLayerBookmarkPresentationID, isMoveLayerActive} from "@/helpers/ol/map/ol-move-helper";
import {triggerChartTooltip} from "@/helpers/chart/chart-helper.js";
import {
    geMeasureLayerStyle,
    getMeasureLayerStyleFunction,
    setActiveMeasureFeature
} from "@/helpers/tools/tools-measure-helper.js";
import {getBySelector} from "@/helpers/element-helper.js";
import {scaleToResolution} from "@/helpers/ol/view/ol-view-resolutation-helper.js";
import {transformExtent} from "ol/proj";

/**
 * Add Web Feature Service
 * @param map
 * @param service
 */
window.wfsStyle = []
export function addServiceWfs(map, service) {

    let serviceUrl = service.Url

    try {
        new URL(serviceUrl);
    } catch (_) {
        serviceUrl = window.kaartViewerUrl + serviceUrl
    }

    const source = {
        format: new GeoJSON(),
        strategy: bboxStrategy,
        attributions: getLayerAttributes(service)
    }

    if(serviceUrl.includes('/map?')) {
        source.loader = function(extent, resolution, projection, success, failure) {
            const url = serviceUrl + 'service=WFS&' +
                'version=1.1.0&request=GetFeature&typename=' + service.Layer + '&' +
                'outputFormat=application/json&srsName=' + service.Service.Projection + '&' +
                'bbox=' +
                transformExtent(extent, getViewProjectionName(), service.Service.Projection).join(',') +
                ',' + service.Service.Projection
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            if(getToken() !== undefined) {
                xhr.setRequestHeader("Authorization", getToken());
            }
            const onError = function() {
                vectorSource.removeLoadedExtent(extent);
                failure();
            }
            xhr.onerror = onError;
            xhr.onload = function() {
                if (xhr.status === 200) {
                    const features = vectorSource.getFormat().readFeatures(xhr.responseText, {featureProjection: getViewProjectionName()});
                    vectorSource.addFeatures(features);

                    success(features);
                } else {
                    onError();
                }
            }
            xhr.send();
        }
    } else {
        source.url = function (extent) {
            return (
                serviceUrl + 'service=WFS&' +
                'version=1.1.0&request=GetFeature&typename=' + service.Layer + '&' +
                'outputFormat=application/json&srsName=' + service.Service.Projection + '&' +
                'bbox=' +
                transformExtent(extent, getViewProjectionName(), service.Service.Projection).join(',') +
                ',' + service.Service.Projection
            );
        }
    }

    removeLoaderByBookmarkPresentationID(service.id)

    const vectorSource = new VectorSource(source);

    const vector = new VectorLayer({
        altitudeMode: 'clampToGround',
        name: getLayerNamePrefix() + service.id,
        zIndex: service.zIndex,
        minResolution: scaleToResolution(service.MinResolution),
        maxResolution: scaleToResolution(service.MaxResolution),
        // style: getDefaultStyleFunction(),
        opacity: service.Opacity / 10,
        // style: getWfsStyle(service.WfsStyle),
        style: getWfsStyleFunction(service),
        source: vectorSource
    });

    map.getLayers().push(vector);

    if(service.Interval) {
        setInterval(() => {
            vector.getSource().refresh();
        }, service.Interval * 1000)
    }

    return vector
}

export function getWfsStyleFunction(service, select = false) {

    console.log(service)

    let wfsStyle = {}
    wfsStyle.id = service.id
    wfsStyle.styles = service.WfsStyle
    window.wfsStyle.push(wfsStyle)

    if(!service.WfsStyle) {
        service.WfsStyle = window.settings.wfsStyle
        service.WfsStyle.styles = window.settings.wfsStyle
    }

    let fillAttributeName
    let fillAttribute
    let fillOpacity
    if(Array.isArray(service.WfsStyle.styles)) {
        const styleItem = service.WfsStyle.styles[0]
        if (styleItem) {
            const styleSetting = styleItem.style_settings
            if (styleSetting) {
                fillAttribute = styleSetting.fillColor
                fillOpacity = styleSetting.fillOpacity
                if (fillAttribute.includes("${")) {
                    fillAttributeName = fillAttribute.replace("${", '').replace('}', '')
                }
            }
        }
    }

    return ((feature) => {

        let style = getWfsStyle(service.WfsStyle, true, false, select, feature)
        if(service.WfsStyle.attribute) {
            style = style[feature.values_[service.WfsStyle.attribute]];
        }

        if(!style) {
            return
        }

        if(typeof style.getText !== "undefined" && style.getText()) {
            let textObject = style.getText().getText()
            if(textObject.includes("${")) {

                // console.log(textObject)

                const regex = /\${(.*?)}/g;
                let match;

                let text = `${textObject}`

                while ((match = regex.exec(textObject)) !== null) {
                    let value = feature.get(match[1])

                    if(!value || value === '-') {
                        value = ''
                    }

                    text = text.replace('${' + match[1] + '}', value.toString())
                }

                style.getText().setText(text)
            }
        }

        if(fillAttributeName) {
            const color = feature.get(fillAttributeName)
            if(color) {
                style.getFill().setColor('rgba(' + hexToRgba(color, fillOpacity) + ')')
                style.getImage().getFill().setColor('rgba(' + hexToRgba(color, fillOpacity) + ')')
            }
        }

        return style
    })
}
const selectStyle = new Style({
    fill: new Fill({
        color: '#eeeeee',
    }),
    stroke: new Stroke({
        color: 'rgba(255, 255, 255, 0.7)',
        width: 2,
    }),
});
let selected = null

export function deselectFeature(override = false) {
    if (selected) {
        if(override) {
            selected.setStyle(undefined);
            selected = null;
        } else {

            // Is vector tile
            if (selected.properties_ || selected.get('selected')) {

            } else {
                selected.setStyle(undefined);
                selected = null;
            }
        }
    }
}
export function selectFeature(feature, type = 'draw') {

    deselectFeature()

    // Disable select for feature with text
    if(feature.get('text')) {
        return
    }

    selected = feature;

    if(type === 'draw') {
        feature.setStyle((feature) => {
            return getMeasureLayerStyleFunction(feature, true, undefined, undefined, [geMeasureLayerStyle(feature, true)])
        })
    } else {
        feature.setStyle(function (feature) {
            return getDefaultStyles('select')[feature.getGeometry().getType()];
        })
    }
}

export function selectFeatureByStyle(f, layer) {

    if(layer instanceof VectorTileLayer) {
        return
    }

    selected = f;

    const service = getBookmarkPresentationsByID(layer.get('name').replace(getLayerNamePrefix(), ''))

    if(service) {
        f.setStyle(getWfsStyleFunction(service, true) )
    } else {
        if(!f.getProperties().kv_projection) {
            f.setStyle(function (feature) {
                return getDefaultStyles('select')[feature.getGeometry().getType()];
            })
        }

    }
}

export function selectVectorFeature(map, pixel, selectType, coordinate = undefined) {

    if(selectType === 'hover') {
        deselectFeature()
    }

    const featureList = []
    map.forEachFeatureAtPixel(pixel, function (f) {
        featureList.push(f)
    })

    let result = false

    map.forEachFeatureAtPixel(pixel, function (f, layer) {

        if(layer === null) {
            selected = null
            return false
        }

        const layerName = layer.getProperties()['name']

        if(layerName === 'notificationGeometry') {
            result = null
            return false
        }

        if(layerName === 'draw-mutation') {
            result = null
            return false
        }



        if(layerName === 'draw-filter') {
            result = false
            selected = null
            return false
        }

        if(layerName === 'ahn-profile') {
            result = false
            selected = null

            triggerChartTooltip(f.get('index'))

            return false
        }

        // Disable vector tile click and hover
        if(layerName === 'layer-mvt-info') {


            if(selectType === 'click') {
                const lastLinkedData = window.lastLinkedData

                let featureID = lastLinkedData.featureID
                featureID = featureID.split('|')

                featureID[1] = coordinate[0].toFixed(0)
                featureID[2] = coordinate[1].toFixed(0)

                window.mvtFeatures = layer.getFeaturesInExtent(new Point(coordinate).getExtent())

                featureID = featureID.join('|')

                loadLinkedData(lastLinkedData.domainID, lastLinkedData.presentationID, featureID, lastLinkedData.index, true)
                selected = f
            }
            return f
        } else {
            delete window.mvtFeatures
        }

        let bookmarkPresentationID = layer.values_.name
        if(bookmarkPresentationID === 'wordPrint' || bookmarkPresentationID === 'print') {
            return false
        }

        if(selectType === 'click') {
            selected = f;

            if((bookmarkPresentationID && bookmarkPresentationID.includes('activeGeoJson-')) || bookmarkPresentationID === 'draw-filter') {
                selected = null
                return false
            }

            bookmarkPresentationID = bookmarkPresentationID.replace(getLayerNamePrefix(), '')

            // const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)
            // if(bookmarkPresentation && bookmarkPresentation.ClickAsWms) {
            //     selected = null
            //     return false
            // }

            if(layer instanceof VectorTileLayer || layer.getSource().getFormat() instanceof EsriJSON) {
                loadTemporaryLayerInfo(layer, f)
            } else if(!isNaN(bookmarkPresentationID)) {

                const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)

                let featureID = f.getId()
                if(bookmarkPresentation.PrimaryKeyName) {
                    featureID = f.get(bookmarkPresentation.PrimaryKeyName)
                }

                if(featureList.length > 1) {
                    const featureIDs = []
                    featureList.map(f => {
                        let featureID = f.getId()
                        if(bookmarkPresentation.PrimaryKeyName) {
                            featureID = f.get(bookmarkPresentation.PrimaryKeyName)
                        }

                        featureIDs.push(featureID)
                    })
                    featureID = featureIDs.join(',')
                }

                callService(bookmarkPresentationID, featureID, 'wfs')

                layer.getSource().getFeatures().map(f => {

                    if(f.get('selected')) {
                        f.set('selected', false)
                        selectFeatureByStyle(f, layer)
                        deselectFeature()
                    }
                })
                f.set('selected', true)

                selectFeatureByStyle(f, layer)
            } else {
                if(getBySelector('layer-info-tools').classList.contains('d-none')) {
                    loadTemporaryLayerInfo(layer, f)
                } else {
                    const element = getBySelector('#divMeasureDrawings a[data-feature-key="' + f.get('key') + '"]')
                    setActiveMeasureFeature(element)
                }
            }
        }

        if(isMoveLayerActive() && ( layer.get('name').includes('activeGeoJson-') || parseInt(layer.get('name').replace('layer-', '')) === getMoveLayerBookmarkPresentationID() ) ) {
            // Don't use hover
        } else {
            if(selectType === 'hover') {
                selectFeatureByStyle(f, layer)
            }
        }

        return true;
    });

    if(selected) {
        result = selected
    }

    return result
}
